"use client";

import cx from "classnames";
const genericHamburgerLine = `block absolute h-0.5 w-5 bg-menu-hamburger-bg transform transition duration-500 ease-in-out`;
const HamburgerButton = props => {
  const {
    open,
    handleOpenMenu,
    showOnMd = true
  } = props;
  return <button className={cx("me-3 size-8 text-black focus:outline-none", {
    "md:hidden": !showOnMd,
    "md:block": showOnMd
  })} onClick={handleOpenMenu} aria-label={open ? "Close menu" : "Open menu"} data-sentry-component="HamburgerButton" data-sentry-source-file="HamburgerButton.jsx">
      <span className={cx(`${genericHamburgerLine}`, {
      "rotate-45": open,
      "-translate-y-1.5": !open
    })} />
      <span className={cx(`${genericHamburgerLine}`, {
      "opacity-0": open,
      "opacity-100": !open
    })} />
      <span className={cx(`${genericHamburgerLine}`, {
      "-rotate-45": open,
      "translate-y-1.5": !open
    })} />
    </button>;
};
export default HamburgerButton;